import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute = () => {
  const { isLoggedIn, isLoadingAuth, setLoginModalOpen } = useContext(AuthContext);

  // Sem login: abre o popup de login e volta pra Home (vitrine), em vez de
  // mandar pra uma página de login dedicada.
  useEffect(() => {
    if (!isLoadingAuth && !isLoggedIn) setLoginModalOpen(true);
  }, [isLoadingAuth, isLoggedIn, setLoginModalOpen]);

  if (isLoadingAuth) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Carregando autenticação...</span>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // // Se a role do usuário não estiver na lista de roles permitidas, redireciona para a dashboard correspondente
  // if (allowedRoles && !allowedRoles.includes(role)) {
  //   let redirectTo;
  //   switch (role) {
  //     case 'READER':
  //       redirectTo = '/reader';
  //       break;
  //     case 'EDITOR':
  //       redirectTo = '/editor';
  //       break;
  //     case 'ADMIN':
  //       redirectTo = '/admin';
  //       break;
  //     default:
  //       redirectTo = '/'; // Redireciona para a home se a role for desconhecida
  //   }
  //   return <Navigate to={redirectTo} replace />;
  // }

  return <Outlet/>;
};

export default ProtectedRoute;